module.exports = __webpack_public_path__ + "img/29.4ab4043.png";